const HOME_WIDGET_SELECTOR = '.homepageTrustpilot';
const HOME_ALIGNMENT_SELECTOR = '.guarantees';
const READY_CLASS = 'is-ready';

function getNumericCssValue(element, propertyName) {
  return Number.parseFloat(getComputedStyle(element).getPropertyValue(propertyName));
}

function getMicroComboWidth(host) {
  return getNumericCssValue(host, '--trustpilot-micro-combo-width');
}

function getMicroComboCenterOffset(host) {
  return getNumericCssValue(host, '--trustpilot-micro-combo-center-offset') || 0;
}

function getAlignmentWidth(host) {
  const microComboWidth = getMicroComboWidth(host);
  const alignmentSource =
    document.querySelector(HOME_ALIGNMENT_SELECTOR) || host.parentElement;
  const measuredWidth =
    alignmentSource?.getBoundingClientRect().width || window.innerWidth;

  return Math.min(microComboWidth, Math.max(0, Math.round(measuredWidth)));
}

function setupHomeTrustpilot() {
  const host = document.querySelector(HOME_WIDGET_SELECTOR);
  if (!host) {
    return;
  }

  let pendingFrame = null;

  const updateWidth = () => {
    const microComboWidth = getMicroComboWidth(host);
    const availableWidth = getAlignmentWidth(host);
    const scale = Math.min(1, availableWidth / microComboWidth);

    pendingFrame = null;
    host.style.setProperty(
      '--trustpilot-micro-combo-available-width',
      `${availableWidth}px`
    );
    host.style.setProperty('--trustpilot-micro-combo-scale', `${scale}`);
    host.style.setProperty(
      '--trustpilot-micro-combo-left-offset',
      `${getMicroComboCenterOffset(host) * scale}px`
    );
  };

  const scheduleUpdate = () => {
    if (pendingFrame !== null) {
      return;
    }

    pendingFrame = window.requestAnimationFrame(updateWidth);
  };

  const reveal = () => {
    scheduleUpdate();
    host.classList.add(READY_CLASS);
  };

  const bindIframeLoad = () => {
    const iframe = host.querySelector('iframe');
    if (!iframe) {
      return false;
    }

    iframe.addEventListener('load', reveal, { once: true });
    window.setTimeout(reveal, 250);

    return true;
  };

  scheduleUpdate();
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if ('ResizeObserver' in window) {
    const alignmentSource = document.querySelector(HOME_ALIGNMENT_SELECTOR);
    if (alignmentSource) {
      new ResizeObserver(scheduleUpdate).observe(alignmentSource);
    }
  }

  if (!bindIframeLoad() && 'MutationObserver' in window) {
    const observer = new MutationObserver(() => {
      if (!bindIframeLoad()) {
        return;
      }

      observer.disconnect();
    });

    observer.observe(host, { childList: true, subtree: true });
  }

  window.setTimeout(reveal, 1500);
}

setupHomeTrustpilot();
